/**
 * Order Management Screen
 * 
 * Main wrapper component that switches between desktop and mobile variants
 * based on screen size. Provides order management functionality for managers.
 * 
 * @module OrderManagementScreen
 */

import React from 'react';
import { OrderManagementScreenDesktop } from './OrderManagementScreenDesktop';
import { OrderManagementScreenMobile } from './OrderManagementScreenMobile';

/**
 * Order Management Screen Component
 * Responsive wrapper that renders appropriate variant based on screen size
 */
export const OrderManagementScreen: React.FC = () => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    /**
     * Check screen size and update mobile state
     */
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    // Initial check
    checkScreenSize();

    // Add resize listener
    window.addEventListener('resize', checkScreenSize);

    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <OrderManagementScreenMobile /> : <OrderManagementScreenDesktop />;
};

